import React, { ReactChild } from "react";
import SystemContext, { SystemContextType } from "./SystemContext";

type Props = {
    context: Partial<SystemContextType>;
    children?: ReactChild;
};

const SystemProvider = (props: Props) => {
    return (
        <SystemContext.Provider value={props.context}>
            {props.children}
        </SystemContext.Provider>
    );
};
export default SystemProvider;
